import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";
import Header from "./components/header";
// ----------------------------------- LAYOUTS -----------------------------------
import MainLayout from "./layouts/mainLayout";
// ----------------------------------- SCREENS -----------------------------------
import Login from "./screens/login";
import PlusLogin from "./screens/plusLogin";
import Home from "./screens/home";
import Dashboard from "./screens/dashboard";
import Dofa from "./screens/dofa";
import GeneralManagement from "./screens/generalManagement";
import ProcessDetails from "./screens/processDetails";
import Clients from "./screens/clients";
import InterestedParties from "./screens/interestedParties";
import SelfAppraisal from "./screens/selfAppraisal/index.js";
import Survey from "./screens/survey/index.js";
import TopProducts from "./screens/topDetails/topProducts.js";
import TopClients from "./screens/topDetails/topClients.js";
import SuperiorRolDashboard from "./screens/superiorRolDashboard/index.js";
import Report_360 from "./screens/report_360/index.js";
import Pai_360 from "./screens/pai_360/index.js";
import BiomedicalManagementDashboard from "./screens/BiomedicalManagementDashboard/index.js";
import ProductDetails from "./screens/topDetails/productDetails.js";
import ManagementDashboardIndicator from "./screens/BiomedicalManagementDashboard/managementDashboardIndicator.js";
import ManageDevice from "./screens/BiomedicalManagementDashboard/manageDevice.js";
import BioMedicalRequest from "./screens/BiomedicalManagementDashboard/requestScreens/bioMedicalRequest.js";
import ServiceRecords from "./screens/BiomedicalManagementDashboard/serviceRecords.js";
import CreateRequest from "./screens/BiomedicalManagementDashboard/requestScreens/createRequest.js";
import MarketingPromotionManagement from "./screens/marketingPromotionManagement/index.js";
import PowerBiLayout from "./layouts/powerBiLayout/index.js";
import RiskAndOpportunityManagement from "./screens/riskAndOpportunityManagement/index.js";
import CreateRisk from "./screens/createRisk/index.js";
import CreateOpportunity from "./screens/createOpportunity/index.js";
import OpportunityDetails from "./screens/opportunityDetails/index.js";
import RiskDetails from "./screens/riskDetails/index.js";
import RiskAdminGestion from "./screens/riskAdminGestion/index.js";
import OpportunityAdminGestion from "./screens/opportunityAdminGestion/index.js";
import ProtectedRoute from "./components/protectedRoute/index.js";
import NotAuthorized from "./screens/NotAuthorized/index.js";
import RegisterBiomedicalEquipment from "./screens/BiomedicalManagementDashboard/registerBiomedicalEquipment.js";
import BiomedicalEquipmentResume from "./screens/BiomedicalManagementDashboard/biomedicalEquipmentResume.js";
import NewTechnicalInspectionAct from "./screens/BiomedicalManagementDashboard/newTechnicalInspectionAct.js";
import BannerAdmin from "./screens/managementDirection/banner_admin/index.js";
import AccompanimentModule from "./screens/marketingPromotionManagement/accompanimentModule/index.js";
import AccompanimentCreation from "./screens/marketingPromotionManagement/accompanimentModule/accompanimentCreation.js";
import AccompanimentPreview from "./screens/marketingPromotionManagement/accompanimentModule/accompanimentPreview.js";
import CreateEngineeringReport from "./screens/BiomedicalManagementDashboard/createEngineeringReport.js";
import BiomedicalAdminPage from "./screens/BiomedicalManagementDashboard/biomedicalAdminPage/index.js";
import DetailBusinessCustomers from "./screens/interestedParties/detailBusinessCustomers";
import Suppliers from "./screens/Suppliers/index.js";
import NationalSuppliers from "./screens/Suppliers/nationalSuppliers/nationalSuppliers.js";
import InternationalSuppliers from "./screens/Suppliers/internationalSuppliers/internationalSuppliers.js";
import ServicesSuppliers from "./screens/Suppliers/servicesSuppliers/servicesSuppliers.js";
import CreateServicesSuppliers from "./screens/Suppliers/servicesSuppliers/create.js";
import CreateInternationalSuppliers from "./screens/Suppliers/internationalSuppliers/create.js";
import CreateNationalSuppliers from "./screens/Suppliers/nationalSuppliers/create.js";
import SeraloginOnline from "./screens/seraloginOnline/index.js";
import SeraloginOnlineLayout from "./layouts/seraloginOnlineLayout/index.js";
import InterestedPartiesProcessDetail from "./screens/interestedParties/interestedPartiesProcessDetail";
import DetailInternalStakeholders from "./screens/interestedParties/detailInternalStakeholders";
import Requirements from "./screens/requirements/index.js";
import InterestedPartiesGraph from "./screens/interestedParties/interestedPartiesGraph.js";
import CreateInterestedParties from "./screens/interestedParties/create.js";
import { BiomedicalFiltersProvider } from "./context/BiomedicalFiltersContext";
import { ServiceOrdersFiltersProvider } from "./context/ServiceOrdersFiltersContext";
import { EngineeringReportFiltersProvider } from "./context/EngineeringReportFiltersContext";
import OganizeTask from "./screens/organizeTask/index.js";
import JustifiedActivities from "./screens/organizeTask/justifiedActivities.js";
import WalletCollection from "./screens/wallet/walletCollection/index.js";
import Wallet from "./screens/wallet/index.js";
import WalletProducts from "./screens/wallet/products/index.js";
import ForeignTradeBoard from "./screens/foreignTrade/index.js";
import NationalizationTime from "./screens/foreignTrade/nationalizationTime/index.js";
import CreateImportNationalizationTime from "./screens/foreignTrade/nationalizationTime/createImport.js";
import InternalClientSatisfaction from "./screens/foreignTrade/internalClientSatisfaction/index.js";
import CreateSurvey from "./screens/foreignTrade/internalClientSatisfaction/createSurvey.js";
import AnswerSurvey from "./screens/foreignTrade/internalClientSatisfaction/answerSurvey.js";
import AnswerSurveyNational from "./screens/foreignTrade/internalClientSatisfaction/answerSurveyNational.js";
import ViewSurveyResults from "./screens/foreignTrade/internalClientSatisfaction/viewSurveyResults.js";
import ExternalClientSatisfaction from "./screens/foreignTrade/externalClientSatisfaction/index.js";
import ExternalCreateSurvey from "./screens/foreignTrade/externalClientSatisfaction/createSurvey.js";
import AnswerSurveyInternational from "./screens/foreignTrade/externalClientSatisfaction/answerSurveyInternational.js";
import ImportExecution from "./screens/foreignTrade/importExecution.js";
import AddAnnualProjectionModal from "./screens/foreignTrade/addAnnualProjectionModal.js";
import ImportRegistration from "./screens/foreignTrade/importRegistration/index.js";
import { getCookie } from "./utils/getCookie";
import { isMicrosoftLoginDisabled } from "./auth/msalConfig";

const legacyLoginUrl = (process.env.REACT_APP_LOGIN_SERALOGIN_URL || "").trim();

const LegacyLoginRedirect = () => {
  React.useEffect(() => {
    if (legacyLoginUrl) {
      window.location.replace(legacyLoginUrl);
    }
  }, []);

  return <p>Redirigiendo a inicio de sesion...</p>;
};

const hasMicrosoftRedirectResponse = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : window.location.hash;
  const hashParams = new URLSearchParams(hash);

  return (
    searchParams.has("code") ||
    searchParams.has("state") ||
    searchParams.has("error") ||
    hashParams.has("code") ||
    hashParams.has("state") ||
    hashParams.has("error")
  );
};

const RootRoute = () => {
  if (isMicrosoftLoginDisabled) {
    const userSesion = getCookie("sesion");
    return userSesion?.id_usuario ? <Home /> : <LegacyLoginRedirect />;
  }

  if (hasMicrosoftRedirectResponse()) {
    return <PlusLogin />;
  }

  const userSesion = getCookie("sesion");
  return userSesion?.id_usuario ? (
    <Home />
  ) : (
    <PlusLogin />
  );
};

function AppContent() {
  const location = useLocation();
  const userSesion = getCookie("sesion");
  const isRootPath = location.pathname === "/";
  const shouldShowRootHeader =
    isRootPath &&
    Boolean(userSesion?.id_usuario) &&
    !hasMicrosoftRedirectResponse();
  //const showHeader = !location.pathname.includes("/seralogin_online");

  const hiddenPaths = [
    "/seralogin_online",
    "oganizeTask",
    "/foreign_trade_board/external_client_satisfaction/international/answer",
    "/login",
    "/login_plus"
  ];
  const showHeader =
    (location.pathname !== "/" || shouldShowRootHeader) &&
    !hiddenPaths.some((path) => location.pathname.includes(path));

  return (
    <>
      {showHeader && <Header />}
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path="/unauthorized" element={<NotAuthorized />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/login_plus"
          element={
            isMicrosoftLoginDisabled ? <LegacyLoginRedirect /> : <PlusLogin />
          }
        />
        <Route
          path="/superior_rol_dashboard"
          element={
            <ProtectedRoute
              path="/superior_rol_dashboard"
              element={
                <MainLayout>
                  <SuperiorRolDashboard />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/360_Report"
          element={
            <ProtectedRoute
              path="/360_Report"
              element={
                <MainLayout>
                  <Report_360 />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              path="/dashboard"
              element={
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/dashboard/dofa/processDetails"
          element={
            <ProtectedRoute
              path="/dashboard/dofa/processDetails"
              element={
                <MainLayout>
                  <ProcessDetails />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/self_appraisal"
          element={
            <ProtectedRoute
              path="/self_appraisal"
              element={
                <MainLayout>
                  <SelfAppraisal />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/self_appraisal/survey"
          element={
            <ProtectedRoute
              path="/self_appraisal/survey"
              element={
                <MainLayout>
                  <Survey />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/general_management"
          element={
            <ProtectedRoute
              path="/general_management"
              element={
                <MainLayout>
                  <GeneralManagement />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/clients"
          element={
            <ProtectedRoute
              path="/clients"
              element={
                <MainLayout>
                  <Clients />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/clients/topClients"
          element={
            <ProtectedRoute
              path="/clients/topClients"
              element={
                <MainLayout>
                  <TopClients />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/clients/topProducts"
          element={
            <ProtectedRoute
              path="/clients/topProducts"
              element={
                <MainLayout>
                  <TopProducts />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/clients/topProducts/details"
          element={
            <ProtectedRoute
              path="/clients/topProducts/details"
              element={
                <MainLayout>
                  <ProductDetails />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/superior_rol_dashboard/Pai_360"
          element={
            <ProtectedRoute
              path="/superior_rol_dashboard/Pai_360"
              element={
                <MainLayout>
                  <Pai_360 />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard"
              element={
                <MainLayout>
                  <BiomedicalManagementDashboard />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/catalogAdmin"
          element={
            <Navigate
              replace
              to="/biomedicalManagementDashboard/biomedicalAdminPage"
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/biomedicalAdminPage"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/biomedicalAdminPage"
              element={
                <MainLayout>
                  <BiomedicalAdminPage />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/indicator"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/indicator"
              element={
                <MainLayout>
                  <ManagementDashboardIndicator />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/manageDevice"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/manageDevice"
              element={
                <MainLayout>
                  <BiomedicalFiltersProvider>
                    <ManageDevice />
                  </BiomedicalFiltersProvider>
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/BioMedicalRequest"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/BioMedicalRequest"
              element={
                <MainLayout>
                  <ServiceOrdersFiltersProvider>
                    <BioMedicalRequest />
                  </ServiceOrdersFiltersProvider>
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/BioMedicalRequest/createRequest"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/BioMedicalRequest/createRequest"
              element={
                <MainLayout>
                  <ServiceOrdersFiltersProvider>
                    <CreateRequest />
                  </ServiceOrdersFiltersProvider>
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/serviceRecords"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/serviceRecords"
              element={
                <MainLayout>
                  <EngineeringReportFiltersProvider>
                    <ServiceRecords />
                  </EngineeringReportFiltersProvider>
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement"
              element={
                <MainLayout>
                  <RiskAndOpportunityManagement />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/dofa"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/dofa"
              element={
                <MainLayout>
                  <Dofa />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/dashboard/dofa"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/dofa"
              element={
                <MainLayout>
                  <Dofa />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/dashboard/dofa"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/dofa"
              element={
                <MainLayout>
                  <Dofa />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/createRisk"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/createRisk"
              element={
                <MainLayout>
                  <CreateRisk />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/createOpportunity"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/createOpportunity"
              element={
                <MainLayout>
                  <CreateOpportunity />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/riskAdminGestion"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/riskAdminGestion"
              element={
                <MainLayout>
                  <RiskAdminGestion />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/riskAdminGestion/riskDetails"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/riskAdminGestion/riskDetails"
              element={
                <MainLayout>
                  <RiskDetails />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/opportunityAdminGestion"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/opportunityAdminGestion"
              element={
                <MainLayout>
                  <OpportunityAdminGestion />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/riskAndOpportunityManagement/opportunityAdminGestion/opportunityDetails"
          element={
            <ProtectedRoute
              path="/riskAndOpportunityManagement/opportunityAdminGestion/opportunityDetails"
              element={
                <MainLayout>
                  <OpportunityDetails />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/marketingPromotionManagement/:powerBi?"
          element={
            <ProtectedRoute
              path="/marketingPromotionManagement"
              element={
                <PowerBiLayout>
                  <MarketingPromotionManagement />
                </PowerBiLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/manageDevice/registerBiomedicalEquipment"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/manageDevice"
              element={
                <MainLayout>
                  <BiomedicalFiltersProvider>
                    <RegisterBiomedicalEquipment />
                  </BiomedicalFiltersProvider>
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/biomedicalManagementDashboard/manageDevice/NewTechnicalInspectionAct"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/manageDevice"
              element={
                <MainLayout>
                  <BiomedicalFiltersProvider>
                    <NewTechnicalInspectionAct />
                  </BiomedicalFiltersProvider>
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/biomedicalManagementDashboard/manageDevice/BiomedicalEquipmentResume"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/manageDevice"
              element={
                <MainLayout>
                  <BiomedicalFiltersProvider>
                    <BiomedicalEquipmentResume />
                  </BiomedicalFiltersProvider>
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/management_direction/banner_admin"
          element={
            <ProtectedRoute
              path="/management_direction"
              element={
                <MainLayout>
                  <BannerAdmin />
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/management_direction"
          element={
            <ProtectedRoute
              path="/management_direction"
              element={
                <MainLayout>
                  <BannerAdmin />
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/marketingPromotionManagement/accompaniment_Module"
          element={
            <ProtectedRoute
              path="/marketingPromotionManagement/accompaniment_Module"
              element={
                <MainLayout>
                  <AccompanimentModule />
                </MainLayout>
              }
            />
          }
        />

        <Route
          path="/marketingPromotionManagement/accompaniment_Module/accompaniment"
          element={
            <ProtectedRoute
              path="/marketingPromotionManagement/accompaniment_Module/accompaniment"
              element={
                <MainLayout>
                  <AccompanimentCreation />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/marketingPromotionManagement/accompaniment_Module/accompanimentPreview"
          element={
            <ProtectedRoute
              path="/marketingPromotionManagement/accompaniment_Module/accompanimentPreview"
              element={
                <MainLayout>
                  <AccompanimentPreview />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/biomedicalManagementDashboard/serviceRecords/createEngineeringReport"
          element={
            <ProtectedRoute
              path="/biomedicalManagementDashboard/serviceRecords"
              element={
                <MainLayout>
                  <EngineeringReportFiltersProvider>
                    <CreateEngineeringReport />
                  </EngineeringReportFiltersProvider>
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers"
          element={
            <ProtectedRoute
              path="/suppliers"
              element={
                <MainLayout>
                  <Suppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/suppliers_national"
          element={
            <ProtectedRoute
              path="/suppliers/suppliers_national"
              element={
                <MainLayout>
                  <NationalSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/international_suppliers"
          element={
            <ProtectedRoute
              path="/suppliers/international_suppliers"
              element={
                <MainLayout>
                  <InternationalSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/services_suppliers"
          element={
            <ProtectedRoute
              path="/suppliers/services_suppliers"
              element={
                <MainLayout>
                  <ServicesSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/suppliers_national/create_new"
          element={
            <ProtectedRoute
              path="/suppliers/suppliers_national/create_new"
              element={
                <MainLayout>
                  <CreateNationalSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/international_suppliers/create_new"
          element={
            <ProtectedRoute
              path="/suppliers/international_suppliers/create_new"
              element={
                <MainLayout>
                  <CreateInternationalSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/suppliers/services_suppliers/create_new"
          element={
            <ProtectedRoute
              path="/suppliers/services_suppliers/create_new"
              element={
                <MainLayout>
                  <CreateServicesSuppliers />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/seralogin_online"
          element={
            <ProtectedRoute
              path="/seralogin_online"
              element={
                <SeraloginOnlineLayout>
                  <SeraloginOnline />
                </SeraloginOnlineLayout>
              }
            />
          }
        />
        <Route
          path="/interestedPartiesGraph"
          element={
            <ProtectedRoute
              path="/interestedPartiesGraph"
              element={
                <MainLayout>
                  <InterestedPartiesGraph />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/gestion_HSQ_GCD/interestedParties"
          element={
            <ProtectedRoute
              path="/gestion_HSQ_GCD/interestedParties"
              element={
                <MainLayout>
                  <InterestedParties />
                </MainLayout>
              }
            />
          }
        />
        {/* <Route
          path="/interestedParties/interestedPartiesExternal"
          element={
            <MainLayout>
              <DetailBusinessCustomers />
            </MainLayout>
          }
        /> */}
        <Route
          path="/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail"
          element={
            <ProtectedRoute
              path="/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail"
              element={
                <MainLayout>
                  <InterestedPartiesProcessDetail />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/interestedParties/detailInternalStakeholders"
          element={
            <ProtectedRoute
              path="/interestedParties/detailInternalStakeholders"
              element={
                <MainLayout>
                  <DetailInternalStakeholders />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail/create"
          element={
            <ProtectedRoute
              path="/gestion_HSQ_GCD/interestedParties/interestedPartiesProcessDetail/create"
              element={
                <MainLayout>
                  <CreateInterestedParties />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/requirements"
          element={
            <ProtectedRoute
              path="/requirements"
              element={
                <MainLayout>
                  <Requirements />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/manage_time"
          element={
            <ProtectedRoute
              path="/manage_time"
              element={
                <MainLayout>
                  <OganizeTask />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/manage_time/justified_activities"
          element={
            <ProtectedRoute
              path="/manage_time/justified_activities"
              element={
                <MainLayout>
                  <JustifiedActivities />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/wallet/products"
          element={
            <ProtectedRoute
              path="/wallet/products"
              element={
                <MainLayout>
                  <WalletProducts />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/wallet/collection"
          element={
            <ProtectedRoute
              path="/wallet/collection"
              element={
                <MainLayout>
                  <WalletCollection />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/wallet"
          element={
            <ProtectedRoute
              path="/wallet"
              element={
                <MainLayout>
                  <Wallet />
                </MainLayout>
              }
            />
          }
        />
        <Route
          path="/foreign_trade_board"
          element={
            <MainLayout>
              <ForeignTradeBoard />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/nationalization_Time"
          element={
            <MainLayout>
              <NationalizationTime />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/nationalization_Time/create_import"
          element={
            <MainLayout>
              <CreateImportNationalizationTime />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/internal_client_satisfaction"
          element={
            <MainLayout>
              <InternalClientSatisfaction />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/internal_client_satisfaction/create"
          element={
            <MainLayout>
              <CreateSurvey />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/internal_client_satisfaction/answer/:token"
          element={
            <MainLayout>
              <AnswerSurvey />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/internal_client_satisfaction/national/answer/:surveyOrderId"
          element={
            <MainLayout>
              <AnswerSurveyNational />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/internal_client_satisfaction/view/:answerId"
          element={
            <MainLayout>
              <ViewSurveyResults />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/external_client_satisfaction"
          element={
            <MainLayout>
              <ExternalClientSatisfaction />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/external_client_satisfaction/create"
          element={
            <MainLayout>
              <ExternalCreateSurvey />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/external_client_satisfaction/international/answer/:surveyOrderId"
          element={
            <MainLayout>
              <AnswerSurveyInternational />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/importExecution"
          element={
            <MainLayout>
              <ImportExecution />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/importExecution/addAnnualProjectionModal"
          element={
            <MainLayout>
              <AddAnnualProjectionModal />
            </MainLayout>
          }
        />
        <Route
          path="/foreign_trade_board/import_registration"
          element={
            <MainLayout>
              <ImportRegistration />
            </MainLayout>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
